import script from "./BrandingHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrandingHeader.vue?vue&type=script&lang=ts&setup=true"

import "./BrandingHeader.vue?vue&type=style&index=0&id=339d599d&lang=scss"

const __exports__ = script;

export default __exports__